<ng-container *ngIf="appModeService.isApp(); else webFallback">
  <section class="addresses-page">
    <header class="header-row">
      <button type="button" class="icon-btn" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
      </button>
    </header>

    <div class="title-row">
      <h1>{{ 'PROFILE.ADDRESSES.PAGE_TITLE' | translate }}</h1>
      <button type="button" class="add-link" (click)="navigateToAdd()">
        {{ 'PROFILE.ADDRESSES.ADD_NEW' | translate }}
      </button>
    </div>

    <section class="content">
      <div class="skeleton-list" *ngIf="isLoading">
        <div class="skeleton-card" *ngFor="let item of [1, 2, 3]"></div>
      </div>

      <div class="error-message" *ngIf="!isLoading && errorMessage">{{ errorMessage | translate }}</div>

      <div class="empty-state" *ngIf="!isLoading && !errorMessage && addresses.length === 0">
        <i class="pi pi-map-marker"></i>
        <p>{{ 'PROFILE.ADDRESSES.EMPTY_STATE' | translate }}</p>
        <button type="button" class="cta-link" (click)="navigateToAdd()">
          {{ 'PROFILE.ADDRESSES.ADD_FIRST' | translate }}
        </button>
      </div>

      <div class="address-list" *ngIf="!isLoading && !errorMessage && addresses.length > 0">
        <app-address-card
          *ngFor="let item of addresses"
          [address]="item"
          (editClicked)="onEditAddress($event)"
        ></app-address-card>
      </div>
    </section>
  </section>
</ng-container>

<ng-template #webFallback>
  <div class="unsupported-view">This page is available in app mode only.</div>
</ng-template>
